import TrustAndExcellenceTabsContent from "../TrustAndExcellenceTabsContent";
import { tabsContent } from "./tabsContent";

export const trustAndExcellenceTextContent = {
  headingText: "Trust & Excellence",
  paraText: "Your Assurance of Compliance, Partnerships, and Accolades",
  btnText: "Book a Meeting",
  content: [
    {
      label: "Compliances",
      content: (
        <TrustAndExcellenceTabsContent images={tabsContent.items[0].imageContent_1} />
      ),
    },
    {
      label: "Data Partners",
      content: (
        <TrustAndExcellenceTabsContent images={tabsContent.items[0].imageContent_2} />
      ),
    },
    {
      label: "Trusted Partners",
      content: (
        <TrustAndExcellenceTabsContent images={tabsContent.items[0].imageContent_3} />
      ),
    },
    {
      label: "Awards & Certifications",
      content: (
        <TrustAndExcellenceTabsContent images={tabsContent.items[0].imageContent_4} />
      ),
    },
  ],
};
